/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AgentHostPreviewsResponse,
  AgentHostWorktreesResponse,
  ReapWorktreeResponse,
  SpinUpPreviewRequest,
  SpinUpPreviewResponse,
} from "../models/index";
import {
  AgentHostPreviewsResponseFromJSON,
  AgentHostPreviewsResponseToJSON,
  AgentHostWorktreesResponseFromJSON,
  AgentHostWorktreesResponseToJSON,
  ReapWorktreeResponseFromJSON,
  ReapWorktreeResponseToJSON,
  SpinUpPreviewRequestFromJSON,
  SpinUpPreviewRequestToJSON,
  SpinUpPreviewResponseFromJSON,
  SpinUpPreviewResponseToJSON,
} from "../models/index";

export interface ReapWorktreeRequest {
  convId: string;
}

export interface SpinUpPreviewOperationRequest {
  convId: string;
  spinUpPreviewRequest: SpinUpPreviewRequest;
}

/**
 *
 */
export class AgentHostPreviewsApi extends runtime.BaseAPI {
  /**
   * List the per-PR preview environments running on the Amy agent-host box
   */
  async getPreviewsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AgentHostPreviewsResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/agent-host/previews`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AgentHostPreviewsResponseFromJSON(jsonValue),
    );
  }

  /**
   * List the per-PR preview environments running on the Amy agent-host box
   */
  async getPreviews(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AgentHostPreviewsResponse> {
    const response = await this.getPreviewsRaw(initOverrides);
    return await response.value();
  }

  /**
   * List the conversation worktrees on the Amy agent-host box with their disk usage
   */
  async getWorktreesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AgentHostWorktreesResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/agent-host/worktrees`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AgentHostWorktreesResponseFromJSON(jsonValue),
    );
  }

  /**
   * List the conversation worktrees on the Amy agent-host box with their disk usage
   */
  async getWorktrees(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AgentHostWorktreesResponse> {
    const response = await this.getWorktreesRaw(initOverrides);
    return await response.value();
  }

  /**
   * Reap a worktree on the Amy box (close the conversation, remove its checkout); refused while a turn is in flight
   */
  async reapWorktreeRaw(
    requestParameters: ReapWorktreeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ReapWorktreeResponse>> {
    if (requestParameters["convId"] == null) {
      throw new runtime.RequiredError(
        "convId",
        'Required parameter "convId" was null or undefined when calling reapWorktree().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/agent-host/worktrees/{convId}/reap`.replace(
          `{${"convId"}}`,
          encodeURIComponent(String(requestParameters["convId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReapWorktreeResponseFromJSON(jsonValue),
    );
  }

  /**
   * Reap a worktree on the Amy box (close the conversation, remove its checkout); refused while a turn is in flight
   */
  async reapWorktree(
    requestParameters: ReapWorktreeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ReapWorktreeResponse> {
    const response = await this.reapWorktreeRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Spin up (or reboot) an Amy preview environment; only valid for a live preview
   */
  async spinUpPreviewRaw(
    requestParameters: SpinUpPreviewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SpinUpPreviewResponse>> {
    if (requestParameters["convId"] == null) {
      throw new runtime.RequiredError(
        "convId",
        'Required parameter "convId" was null or undefined when calling spinUpPreview().',
      );
    }

    if (requestParameters["spinUpPreviewRequest"] == null) {
      throw new runtime.RequiredError(
        "spinUpPreviewRequest",
        'Required parameter "spinUpPreviewRequest" was null or undefined when calling spinUpPreview().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/agent-host/previews/{convId}/spin-up`.replace(
          `{${"convId"}}`,
          encodeURIComponent(String(requestParameters["convId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SpinUpPreviewRequestToJSON(
          requestParameters["spinUpPreviewRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SpinUpPreviewResponseFromJSON(jsonValue),
    );
  }

  /**
   * Spin up (or reboot) an Amy preview environment; only valid for a live preview
   */
  async spinUpPreview(
    requestParameters: SpinUpPreviewOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SpinUpPreviewResponse> {
    const response = await this.spinUpPreviewRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
